import { FC } from "react";
import { Tag as AntTag } from "antd";
import styles from "./Tag.module.css";
import TagProps from "./types/TagProps";
import getIcon from "utils/getIcon";

const Tag: FC<TagProps> = ({ children, onClose, closable = true }) => {
	const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
		event.preventDefault();
		event.stopPropagation();
	};

	return (
		<AntTag className={styles["tag"]} onMouseDown={onPreventMouseDown} closable={closable} onClose={onClose} closeIcon={getIcon({ icon: "closeIconSecondary" })}>
			{children}
		</AntTag>
	);
};

export default Tag;
